export const SheetSectionEmptyText = ({ text }: { text: string }) => {
  return <p className="font-medium text-slate-500">{text}</p>;
};
